module.exports = __webpack_public_path__ + "static/media/video1.f7948fd1.mp4";